import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import updateIcon from '@jetbrains/icons/update';
import { ActionableNotificationContent } from '@app/common/notifications';
export function ConfigurationChangedNotification() {
    return (_jsx(ActionableNotificationContent, { icon: updateIcon, description: _jsxs(_Fragment, { children: ["Client machine configuration is updated. ", _jsx("br", {}), "Distribute the updated configuration file to developer machines."] }) }));
}
